module.exports = __webpack_public_path__ + "static/media/oxygen-tank.6974948d.svg";